<template>
    <div class="view view--add-admin-user">
        <edit-user />
    </div>
</template>

<script>
    import editUser from '../../components/EditUser.vue';

    export default {
        components: {
            editUser
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/users/Add.vue